import {
  EmptyState,
  LoadingButton,
} from '@airship-platform/jam-web/components';
import { Link, useNavigate } from 'react-router';
import { useAppointmentProposals } from '../../../data-access/appointmentProposals';
import { SectionWrapper } from '../../../patterns';
import NotesSection, { NotesSectionInputs } from './sections/NotesSection';

const FORM_ID = 'proposalNotesForm';

const CaptureNotesPage: React.FC = () => {
  const navigate = useNavigate();
  const { currentProposal, isLoading, updateAppointmentProposal } =
    useAppointmentProposals();

  if (!currentProposal) {
    return (
      <EmptyState
        title="Appointment not found"
        subtitle="Oops! The requested appointment was not found."
      />
    );
  }

  const onSubmit = (notes: NotesSectionInputs) =>
    updateAppointmentProposal(
      currentProposal.appointmentId,
      currentProposal.appointmentProposalId,
      { ...notes }
    ).then(() => navigate(-1));

  return (
    <SectionWrapper
      maxWidth={'28rem'}
      width={'100%'}
      header="Add internal job notes"
      subheader="These notes are for your install crew and office staff. They help ensure a smooth job, but won't be visible to the customer or shown on the proposal.
"
      actionsButtons={{
        left: {
          color: 'softGold',
          component: Link,
          to: '../service-menu',
          label: 'Cancel',
        },
        right: {
          type: 'submit',
          component: LoadingButton,
          form: FORM_ID,
          label: 'Save',
          loading: isLoading,
          disabled: isLoading,
        },
      }}
    >
      <NotesSection
        formId={FORM_ID}
        defaultValues={currentProposal}
        onSubmit={onSubmit}
      />
    </SectionWrapper>
  );
};

export default CaptureNotesPage;
